/**
 * A remote request call helper that takes care of boilerplate for common errors
 */
export function callApi<T>(getToken: () => string | undefined, serviceMethod: (fetcher: (url: string, init: RequestInit) => Promise<Response>) => Promise<T>, 
        invalidTokenAction: (success: () => void, expired: boolean) => void, 
        handleUnauthorized: (success: () => void) => void): Promise<T> {

    return new Promise<T>(async (resolve, reject) => {
        try {
            resolve(await serviceMethod(
                async (url: string, init: RequestInit) => {
                    // ensure we are dealing with a Headers
                    const headers = new Headers(init.headers);
                    headers.set('Authorization', `Bearer ${getToken()}`);
                    init.headers = headers;
                    
                    const resp = await fetch(url, init);
                    
                    if (!resp.ok) {
                        let body = null;
                        if (resp.headers.has("Content-Type") && (resp.headers.get("Content-Type") || '').match(/json/)) {
                            body = await resp.json();
                        }
                        throw { 
                            statusCode: resp.status, 
                            resp, 
                            body: body,
                            expired: resp.headers.has('Token-Expired')
                        };
                    }
                    return resp;
                }
            ));
        } catch (err) {
            if (err.statusCode == 401) {
                const success = () => {
                    resolve(callApi<T>(getToken, serviceMethod, invalidTokenAction, handleUnauthorized));
                };
                invalidTokenAction(success, err.expired);
                handleUnauthorized(success);
            } else {
                reject(err);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/api.ts